import { render } from "./sys-model.vue?vue&type=template&id=1256f5da&scoped=true"
import script from "./sys-model.vue?vue&type=script&lang=js"
export * from "./sys-model.vue?vue&type=script&lang=js"

import "./sys-model.vue?vue&type=style&index=0&id=1256f5da&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1256f5da"]])

export default __exports__